import {useMyEnrollments} from '@/modules/transaction';
import {useIsLimitedAccess} from '@/modules/user/components/LimitedAccess/hooks';

export const useExcessContributionAvailable = () => {
  const isLimitedAccessUser = useIsLimitedAccess();
  const { hasOpenHSA } = useMyEnrollments();
  return {
    isExcessContributionAvailable: Boolean(hasOpenHSA && !isLimitedAccessUser),
  };
};
